<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <app-layout>
    <div class="max-w-full mt-20">
      <div class="relative">
        <!-- Overlapping background -->
        <div aria-hidden="true" class="hidden absolute bg-gray-50 w-full h-6 bottom-0 lg:block"/>

        <div class="relative max-w-2xl mx-auto px-4 text-center sm:px-6 lg:max-w-7xl lg:px-8">
          <h1 class="text-4xl font-extrabold tracking-tight text-black sm:text-6xl">
            <span class="block lg:inline">Try AgileSuite with a 7 day free trial</span>
          </h1>
          <p class="mt-4 text-xl text-gray-500">Pick a plan that best suits your business.</p>
        </div>

        <h2 class="sr-only">Plans</h2>

        <!-- Toggle -->
        <!--        <div class="relative mt-12 flex justify-center sm:mt-16">-->
        <!--          <div class="bg-blue-700 p-0.5 rounded-lg flex">-->
        <!--            <button type="button" class="relative bg-white py-2 px-6 border-indigo-700 rounded-md shadow-sm text-sm font-medium text-blue-700 whitespace-nowrap hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white focus:z-10">Monthly billing</button>-->
        <!--            <button type="button" class="ml-0.5 relative py-2 px-6 border border-transparent rounded-md text-sm font-medium text-blue-200 whitespace-nowrap hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white focus:z-10">Yearly billing</button>-->
        <!--          </div>-->
        <!--        </div>-->

        <!-- Cards -->
        <div class="relative mt-8 max-w-2xl mx-auto px-4 pb-8 sm:mt-12 sm:px-6 lg:max-w-7xl lg:px-8 lg:pb-0">
          <!-- Decorative background -->
          <div aria-hidden="true"
               class="hidden absolute top-4 bottom-6 left-8 right-8 inset-0 bg-blue-400 rounded-tl-lg rounded-tr-lg lg:block"/>

          <div class="relative space-y-6 lg:space-y-0 lg:grid lg:grid-cols-3">
            <div v-for="plan in plans" :key="plan.title"
                 :class="[plan.featured ? 'bg-white ring-2 ring-blue-700 shadow-md' : 'bg-blue-500 lg:bg-transparent', 'pt-6 px-6 pb-3 rounded-lg lg:px-8 lg:pt-12']">
              <div>
                <h3 :class="[plan.featured ? 'text-blue-600' : 'text-white', 'text-sm font-semibold uppercase tracking-wide']">
                  {{ plan.title }}</h3>
                <div
                    class="flex flex-col items-start sm:flex-row sm:items-center sm:justify-between lg:flex-col lg:items-start">
                  <div class="mt-3 flex items-center">
                    <p :class="[plan.featured ? 'text-blue-600' : 'text-white', 'text-4xl font-extrabold tracking-tight']">
                      ${{ plan.priceMonthly }}</p>
                    <div class="ml-4">
                      <p :class="[plan.featured ? 'text-gray-700' : 'text-white', 'text-sm']">USD / mo</p>
                    </div>
                  </div>

                  <a :href="'/billing?subscribe='+plan.key"
                      type="button"
                      class="
                    rounded-full
                    transition
                    duration-200
                    bg-yellow-400
                    hover:bg-yellow-300
                    focus:outline-none
                    text-black
                    w-full
                    py-1
                    rounded-md
                    text-md
                    font-semibold
                    text-center
                    inline-block
                  "
                  >
                    <span class="inline-block mr-2">

      Start 7 day free trial
                    </span>
                  </a>
                </div>
              </div>
              <h4 class="sr-only">Features</h4>
              <ul role="list"
                  :class="[plan.featured ? 'border-gray-200 divide-gray-200' : 'border-indigo-500 divide-indigo-500 divide-opacity-75', 'mt-7 border-t divide-y lg:border-t-0']">
                <li v-for="mainFeature in plan.mainFeatures" :key="mainFeature.id" class="py-3 flex items-center">
                  <CheckIcon :class="[plan.featured ? 'text-blue-500' : 'text-blue-200', 'w-5 h-5 flex-shrink-0']"
                             aria-hidden="true"/>
                  <span :class="[plan.featured ? 'text-gray-600' : 'text-white', 'ml-3 text-sm font-medium']">{{
                      mainFeature.value
                    }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Feature comparison (up to lg) -->
      <section aria-labelledby="mobile-comparison-heading" class="lg:hidden">
        <h2 id="mobile-comparison-heading" class="sr-only">Feature comparison</h2>

        <div class="max-w-2xl mx-auto py-16 px-4 space-y-16 sm:px-6">
          <div v-for="(plan, mobilePlanIndex) in plans" :key="mobilePlanIndex" class="border-t border-gray-200">
            <div
                :class="[plan.featured ? 'border-indigo-600' : 'border-transparent', '-mt-px pt-6 border-t-2 sm:w-1/2']">
              <h3 :class="[plan.featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-bold']">{{
                  plan.title
                }}</h3>
              <p class="mt-2 text-sm text-gray-500">{{ plan.description }}</p>
            </div>
            <h4 class="mt-10 text-sm font-bold text-gray-900">Planning Poker</h4>

            <div class="mt-6 relative">
              <!-- Fake card background -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'shadow-md' : 'shadow', 'absolute right-0 w-1/2 h-full bg-white rounded-lg']"/>
              </div>

              <div
                  :class="[plan.featured ? 'ring-2 ring-blue-600 shadow-md' : 'ring-1 ring-black ring-opacity-5 shadow', 'relative py-3 px-4 bg-white rounded-lg sm:p-0 sm:bg-transparent sm:rounded-none sm:ring-0 sm:shadow-none']">
                <dl class="divide-y divide-gray-200">
                  <div v-for="feature in features" :key="feature.title"
                       class="py-3 flex items-center justify-between sm:grid sm:grid-cols-2">
                    <dt class="pr-4 text-sm font-medium text-gray-600">{{ feature.title }}</dt>
                    <dd class="flex items-center justify-end sm:px-4 sm:justify-center">
                      <span v-if="typeof feature.tiers[mobilePlanIndex].value === 'string'"
                            :class="[feature.tiers[mobilePlanIndex].featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-medium']">{{
                          feature.tiers[mobilePlanIndex].value
                        }}</span>
                      <template v-else>
                        <CheckIcon v-if="feature.tiers[mobilePlanIndex].value === true"
                                   class="mx-auto h-5 w-5 text-blue-600" aria-hidden="true"/>
                        <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                        <span class="sr-only">{{ feature.tiers[mobilePlanIndex].value === true ? 'Yes' : 'No' }}</span>
                      </template>
                    </dd>
                  </div>
                </dl>
              </div>

              <!-- Fake card border -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'ring-2 ring-blue-600' : 'ring-1 ring-black ring-opacity-5', 'absolute right-0 w-1/2 h-full rounded-lg']"/>
              </div>
            </div>

            <h4 class="mt-10 text-sm font-bold text-gray-900">Retro (Upcoming)</h4>

            <div class="mt-6 relative">
              <!-- Fake card background -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'shadow-md' : 'shadow', 'absolute right-0 w-1/2 h-full bg-white rounded-lg']"/>
              </div>

              <div
                  :class="[plan.featured ? 'ring-2 ring-blue-600 shadow-md' : 'ring-1 ring-black ring-opacity-5 shadow', 'relative py-3 px-4 bg-white rounded-lg sm:p-0 sm:bg-transparent sm:rounded-none sm:ring-0 sm:shadow-none']">
                <dl class="divide-y divide-gray-200">
                  <div v-for="perk in perks" :key="perk.title" class="py-3 flex justify-between sm:grid sm:grid-cols-2">
                    <dt class="text-sm font-medium text-gray-600 sm:pr-4">{{ perk.title }}</dt>
                    <dd class="text-center sm:px-4">
                      <CheckIcon v-if="perk.tiers[mobilePlanIndex].value === true" class="mx-auto h-5 w-5 text-blue-600"
                                 aria-hidden="true"/>
                      <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                      <span class="sr-only">{{ perk.tiers[mobilePlanIndex].value === true ? 'Yes' : 'No' }}</span>
                    </dd>
                  </div>
                </dl>
              </div>

              <!-- Fake card border -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'ring-2 ring-blue-600' : 'ring-1 ring-black ring-opacity-5', 'absolute right-0 w-1/2 h-full rounded-lg']"/>
              </div>
            </div>


            <h4 class="mt-10 text-sm font-bold text-gray-900">Stand-Up</h4>

            <div class="mt-6 relative">
              <!-- Fake card background -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'shadow-md' : 'shadow', 'absolute right-0 w-1/2 h-full bg-white rounded-lg']"/>
              </div>

              <div
                  :class="[plan.featured ? 'ring-2 ring-blue-600 shadow-md' : 'ring-1 ring-black ring-opacity-5 shadow', 'relative py-3 px-4 bg-white rounded-lg sm:p-0 sm:bg-transparent sm:rounded-none sm:ring-0 sm:shadow-none']">
                <dl class="divide-y divide-gray-200">
                  <div v-for="perk in standUp" :key="perk.title"
                       class="py-3 flex justify-between sm:grid sm:grid-cols-2">
                    <dt class="text-sm font-medium text-gray-600 sm:pr-4">{{ perk.title }}</dt>
                    <dd class="text-center sm:px-4">
                      <CheckIcon v-if="perk.tiers[mobilePlanIndex].value === true" class="mx-auto h-5 w-5 text-blue-600"
                                 aria-hidden="true"/>
                      <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                      <span class="sr-only">{{ perk.tiers[mobilePlanIndex].value === true ? 'Yes' : 'No' }}</span>
                    </dd>
                  </div>
                </dl>
              </div>

              <!-- Fake card border -->
              <div aria-hidden="true" class="hidden absolute inset-0 pointer-events-none sm:block">
                <div
                    :class="[plan.featured ? 'ring-2 ring-blue-600' : 'ring-1 ring-black ring-opacity-5', 'absolute right-0 w-1/2 h-full rounded-lg']"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Feature comparison (lg+) -->
      <section aria-labelledby="comparison-heading" class="hidden lg:block">
        <h2 id="comparison-heading" class="sr-only">Planning Poker comparison</h2>

        <div class="max-w-7xl mx-auto py-24 px-8">
          <div class="w-full border-t border-gray-200 flex items-stretch">
            <div class="-mt-px w-1/4 py-6 pr-4 flex items-end">
              <h3 class="mt-auto text-sm font-bold text-gray-900">Planning Poker</h3>
            </div>
            <div v-for="(plan, planIdx) in plans" :key="plan.title" aria-hidden="true"
                 :class="[planIdx === plans.length - 1 ? '' : 'pr-4', '-mt-px pl-4 w-1/4']">
              <div :class="[plan.featured ? 'border-indigo-600' : 'border-transparent', 'py-6 border-t-2']">
                <p :class="[plan.featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-bold']">{{
                    plan.title
                  }}</p>
                <p class="mt-2 text-sm text-gray-500">{{ plan.description }}</p>
              </div>
            </div>
          </div>

          <div class="relative">
            <!-- Fake card backgrounds -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow-md"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
            </div>

            <table class="relative w-full">
              <caption class="sr-only">
                Planning Poker comparison
              </caption>
              <thead>
              <tr class="text-left">
                <th scope="col">
                  <span class="sr-only">Feature</span>
                </th>
                <th v-for="plan in plans" :key="plan.title" scope="col">
                  <span class="sr-only">{{ plan.title }} plan</span>
                </th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">
              <tr v-for="feature in features" :key="feature.title">
                <th scope="row" class="w-1/4 py-3 pr-4 text-left text-sm font-medium text-gray-600">{{
                    feature.title
                  }}
                </th>
                <td v-for="(tier, tierIdx) in feature.tiers" :key="tier.title"
                    :class="[tierIdx === feature.tiers.length - 1 ? 'pl-4' : 'px-4', 'relative w-1/4 py-0 text-center']">
                  <span class="relative w-full h-full py-3">
                    <span v-if="typeof tier.value === 'string'"
                          :class="[tier.featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-medium']">{{
                        tier.value
                      }}</span>
                    <template v-else>
                      <CheckIcon v-if="tier.value === true" class="mx-auto h-5 w-5 text-blue-600" aria-hidden="true"/>
                      <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                      <span class="sr-only">{{ tier.value === true ? 'Yes' : 'No' }}</span>
                    </template>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>

            <!-- Fake card borders -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-2 ring-blue-600 ring-opacity-100"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
            </div>
          </div>

          <h3 class="mt-10 text-sm font-bold text-gray-900">Retro （Upcoming)</h3>

          <div class="mt-6 relative">
            <!-- Fake card backgrounds -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow-md"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
            </div>

            <table class="relative w-full">
              <caption class="sr-only">
                Retro comparison
              </caption>
              <thead>
              <tr class="text-left">
                <th scope="col">
                  <span class="sr-only">Perk</span>
                </th>
                <th v-for="plan in plans" :key="plan.title" scope="col">
                  <span class="sr-only">{{ plan.title }} plan</span>
                </th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">
              <tr v-for="feature in perks" :key="feature.title">
                <th scope="row" class="w-1/4 py-3 pr-4 text-left text-sm font-medium text-gray-600">{{
                    feature.title
                  }}
                </th>
                <td v-for="(tier, tierIdx) in feature.tiers" :key="tier.title"
                    :class="[tierIdx === feature.tiers.length - 1 ? 'pl-4' : 'px-4', 'relative w-1/4 py-0 text-center']">
                  <span class="relative w-full h-full py-3">
                    <span v-if="typeof tier.value === 'string'"
                          :class="[tier.featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-medium']">{{
                        tier.value
                      }}</span>
                    <template v-else>
                      <CheckIcon v-if="tier.value === true" class="mx-auto h-5 w-5 text-blue-600" aria-hidden="true"/>
                      <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                      <span class="sr-only">{{ tier.value === true ? 'Yes' : 'No' }}</span>
                    </template>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>

            <!-- Fake card borders -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-2 ring-blue-600 ring-opacity-100"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
            </div>
          </div>


          <h3 class="mt-10 text-sm font-bold text-gray-900">Stand-Up</h3>

          <div class="mt-6 relative">
            <!-- Fake card backgrounds -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full bg-white rounded-lg shadow-md"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full bg-white rounded-lg shadow"/>
              </div>
            </div>

            <table class="relative w-full">
              <caption class="sr-only">
                Standup comparison
              </caption>
              <thead>
              <tr class="text-left">
                <th scope="col">
                  <span class="sr-only">Stand-Up</span>
                </th>
                <th v-for="plan in plans" :key="plan.title" scope="col">
                  <span class="sr-only">{{ plan.title }} plan</span>
                </th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-100">

              <tr v-for="feature in standUp" :key="feature.title">
                <th scope="row" class="w-1/4 py-3 pr-4 text-left text-sm font-medium text-gray-600">{{
                    feature.title
                  }}
                </th>
                <td v-for="(tier, tierIdx) in feature.tiers" :key="tier.title"
                    :class="[tierIdx === feature.tiers.length - 1 ? 'pl-4' : 'px-4', 'relative w-1/4 py-0 text-center']">
                  <span class="relative w-full h-full py-3">
                    <span v-if="typeof tier.value === 'string'"
                          :class="[tier.featured ? 'text-blue-600' : 'text-gray-900', 'text-sm font-medium']">{{
                        tier.value
                      }}</span>
                    <template v-else>
                      <CheckIcon v-if="tier.value === true" class="mx-auto h-5 w-5 text-blue-600" aria-hidden="true"/>
                      <XIcon v-else class="mx-auto h-5 w-5 text-gray-400" aria-hidden="true"/>
                      <span class="sr-only">{{ tier.value === true ? 'Yes' : 'No' }}</span>
                    </template>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>

            <!-- Fake card borders -->
            <div class="absolute inset-0 flex items-stretch pointer-events-none" aria-hidden="true">
              <div class="w-1/4 pr-4"/>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
              <div class="w-1/4 px-4">
                <div class="w-full h-full rounded-lg ring-2 ring-blue-600 ring-opacity-100"/>
              </div>
              <div class="w-1/4 pl-4">
                <div class="w-full h-full rounded-lg ring-1 ring-black ring-opacity-5"/>
              </div>
            </div>
          </div>
        </div>
      </section>





      <section>
        <div class="bg-gray-100">
          <div class="pt-12 sm:pt-16 lg:pt-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div class="text-center">
                <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
                  Enterprise? Not find your plan? No worries, lets talk.
                </h2>
              </div>
            </div>
          </div>
          <div class="mt-8 pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
            <div class="relative">
              <div class="absolute inset-0 h-1/2 bg-gray-100" />
              <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
                  <div class="flex-1 bg-white px-6 py-8 lg:p-12">
                    <p class="mt-6 text-base text-gray-500">
                      If you need more customised pricing model, please just reach us and we will do our best to satisfy your expectations.
                    </p>
                  </div>
                  <div class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">

                    <div class="mt-6">
                      <div class="rounded-md shadow">
                        <a href="/contact-us" class="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-400 hover:bg-orange-200">
                          Contact Us
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </app-layout>

</template>

<script>
import {CheckIcon, XIcon} from '@heroicons/vue/solid'
import AppLayout from "@/Layouts/AppLayout";

const plans = [
  {
    title: 'Starter',
    featured: false,
    description: 'For business size between 1 to 10.',
    priceMonthly: 39,
    priceYearly: 56,
    mainFeatures: [],
    key: 'price_1JQzWcKmx1r6EwnROEpXVl0b'
  },
  {
    title: 'Scale',
    featured: true,
    description: 'For business size between 10 to 100.',
    priceMonthly: 79,
    priceYearly: 220,
    mainFeatures: [],
    key: 'price_1JQzWcKmx1r6EwnROEpXVl0b'
  },
  {
    title: 'Growth',
    featured: false,
    description: 'For business size > 200',
    priceMonthly: 129,
    priceYearly: 140,
    mainFeatures: [],
    key: 'price_1JQzWcKmx1r6EwnROEpXVl0b'
  },
]
const features = [
  {
    title: 'Number of rooms',
    tiers: [
      {title: 'starter', value: '2'},
      {title: 'popular', featured: true, value: '15'},
      {title: 'intermediate', value: '30'},
    ],
  },
  {
    title: 'Unlimited players per room',
    tiers: [
      {title: 'starter', value: true},
      {title: 'popular', featured: true, value: true},
      {title: 'intermediate', value: true},
    ],
  }
]
const perks = [
  {
    title: 'Number of rooms',
    tiers: [
      {title: 'starter', value: '2'},
      {title: 'popular', featured: true, value: '15'},
      {title: 'intermediate', value: '30'},
    ],
  },
  {
    title: 'Unlimited players per room',
    tiers: [
      {title: 'starter', value: true},
      {title: 'popular', featured: true, value: true},
      {title: 'intermediate', value: true},
    ],
  }
]

const standUp = [
  {
    title: 'Number of reports',
    tiers: [
      {title: 'starter', value: '5'},
      {title: 'popular', featured: true, value: '10'},
      {title: 'intermediate', value: '15'},
    ],
  },
  {
    title: 'Unlimited participants per report',
    tiers: [
      {title: 'starter', value: '15'},
      {title: 'popular', featured: true, value: '20'},
      {title: 'intermediate', value: '30'},
    ],
  }
]

export default {
  components: {
    AppLayout,
    CheckIcon,
    XIcon,
  },
  setup() {
    return {
      plans,
      features,
      perks,
      standUp
    }
  },
}
</script>